import React, { Component } from "react";
import "./auth.css";
import { connect } from "react-redux";
import { signin, microsoftSignin } from "../../store/actions/authActions";
import { Redirect } from "react-router-dom";
class signIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
    };
  }
  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };
  handleSubmit = (e) => {
    e.preventDefault();

    this.props.signIn(this.state);
  };
  anotherSubmit = () => {
    this.props.microsoftSignin();
  };
  render() {
    const { authError, auth } = this.props;
    if (auth.uid) {
      return <Redirect to="/" />;
    } else {
      return (
        <div className="container">
          <form className="white" onSubmit={this.handleSubmit}>
            <h5 className="grey-text text-darken-3">Sign In</h5>

            <div className="input-text">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" onChange={this.handleChange} />
            </div>
            <div className="input-text">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                onChange={this.handleChange}
              />
            </div>
            <div className="input-field">
              <button className="btn orange lighton-1 z-depth-0">Login</button>
              <div className="red-text center">
                {authError ? <p>{authError}</p> : null}
              </div>
            </div>
          </form>
          {/* <button className="orange-text" onClick={this.anotherSubmit}>
            sign in with microsoft
          </button> */}
        </div>
      );
    }
  }
}
const mapStateToProps = (state) => {
  return {
    authError: state.auth.authError,
    auth: state.firebase.auth,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    signIn: (creds) => {
      dispatch(signin(creds));
    },
    microsoftSignin: () => {
      dispatch(microsoftSignin());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(signIn);
